module.exports = __webpack_public_path__ + "img/ic_order_rejected_circle_filled.4be7a218.png";